import React from 'react';
import Button, { ButtonPositionProps, ButtonToneProps } from 'src/components/ui/Button/Button';
import { useTranslation } from 'react-i18next';
import Image from 'src/components/ui/Image/Image';
import { SaleOrder } from 'src/services/saleOrder';
import styles from './OrderLinesTable.module.scss';

export interface OrderLinesTableProps {
  item: SaleOrder;
}

const OrderLinesTable: React.FC<OrderLinesTableProps> = ({ item }) => {
  const { t } = useTranslation();
  return (
    <div className="pt-16 flex flex-col gap-y-16">
      {item?.carrier &&
        'shipping_lines' in item.carrier &&
        item?.carrier?.shipping_lines &&
        item.carrier.shipping_lines.map(line => (
          <div key={line.tracking_id} className={styles.root}>
            <div className={styles.carrierWrapper}>
              <Image
                className={styles.carrier}
                imageUrl={item?.carrier?.logo_url || ''}
                alt={item?.carrier?.name || 'carrier-logo'}
                fallbackComponent={<div className="surface-elevated" />}
              />
            </div>
            <div className="flex flex-col gap-y-6">
              <span className="typo-text-12 text-faded">{line.tracking_url}</span>
            </div>
            <div className="ml-auto flex items-center gap-x-8">
              <Button
                icon="arrowRight"
                className={styles.trackButton}
                onClick={() => window.open(line.tracking_url || '/', '_blank')}
                title={t('general.track')}
                iconPosition={ButtonPositionProps.AFTER}
                tone={ButtonToneProps.SECONDARY}
              />
              <Button icon="settings" onClick={() => {}} tone={ButtonToneProps.SECONDARY} />
            </div>
          </div>
        ))}
    </div>
  );
};

export default OrderLinesTable;
